import { styled } from '../../Styles/stitches.config'

const StartEndIcon = {
    display: 'flex',
    placeContent: 'center',
}

export const StartIcon = styled('div', {
    ...StartEndIcon,
    ml: '-$1',
    mr: '$1',
})

export const EndIcon = styled('div', {
    ...StartEndIcon,
    ml: '$1',
    mr: '-$1',
})

export const StyledButton = styled('button', {
    alignItems: 'center',
    border: '1px solid',
    br: '$1',
    cursor: 'pointer',
    display: 'flex',
    fontWeight: 600,
    justifyContent: 'center',
    lineHeight: 1,
    px: '$3',
    transition: '$default',

    '&:disabled': {
        cursor: 'default',
        pointerEvents: 'none',
    },

    variants: {
        rrdisabled: {
            true: {},
        },

        active: {
            true: {},
        },
        rounded: {
            true: {
                br: 9999,
            },
        },
        size: {
            small: {
                fontSize: '0.875rem',
                h: 24,
            },
            medium: {
                h: 32,
            },
            large: {
                fontSize: '1.125rem',
                h: 48,
            },
        },
        variant: {
            danger: {
                bc: '$error600',
                bgc: '$error600',
                color: '$white',

                '@canHover': {
                    '&:hover': {
                        bc: '$error500',
                        bgc: '$error500',
                    },
                },

                '&:disabled': {
                    bc: '$error400',
                    bgc: '$error400',
                },
            },
            default: {
                bc: '$primary600',
                bgc: 'transparent',
                color: '$primary600',

                '@canHover': {
                    '&:hover': {
                        bc: '$primary500',
                        color: '$primary500',
                    },
                },

                '&:disabled': {
                    bc: '$primary400',
                    color: '$primary400',
                },
            },
            option: {
                bc: '$primary600',
                bgc: 'transparent',
                color: '$primary600',

                '@canHover': {
                    '&:hover': {
                        bgc: '$primary500',
                        bc: '$primary500',
                        color: '$white',
                    },
                },

                '&:disabled': {
                    bc: '$primary400',
                    color: '$primary400',
                },
            },
            plain: {
                bgc: 'transparent',
                bc: 'transparent',
                color: '$primary600',

                '@canHover': {
                    '&:hover': {
                        bgc: '$neutral100',
                        bc: '$neutral100',
                    },
                },

                '&:disabled': {
                    color: '$primary400',
                },
            },
            success: {
                bc: '$secondary500',
                bgc: '$secondary500',
                color: '$primary600',

                '@canHover': {
                    '&:hover': {
                        bgc: '$secondary600',
                        bc: '$secondary600',
                    },
                },

                '&:disabled': {
                    bc: '$secondary400',
                    bgc: '$secondary400',
                    color: '$primary400',
                },
            },
        },
    },

    defaultVariants: {
        active: false,
        size: 'medium',
        variant: 'default',
    },

    compoundVariants: [
        {
            variant: 'option',
            active: true,
            css: {
                bgc: '$primary600',
                color: '$white',
            },
        },
        {
            variant: 'success',
            rrdisabled: false,
            css: {
                borderColor: 'var(--rr-colors-secondary500)',
                backgroundColor: 'var(--rr-colors-secondary500)',
                color: 'var(--rr-colors-primary600)',
            },
        },
        {
            rrdisabled: true,
            variant: 'success',
            css: {
                borderColor: 'var(--rr-colors-secondary400)',
                backgroundColor: 'var(--rr-colors-secondary400)',
                color: 'var(--rr-colors-primary400)',
            },
        },
    ],
})
